import React, {useState, useEffect} from "react";
import "./post.css";
import Avatar from "@material-ui/core/Avatar";
import {db} from "./Firebase";
import firebase from "firebase";

function Post(props) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");

  function postComment(event){
    event.preventDefault();

    db.collection("posts").doc(props.postid).collection("comments").add({
      text: comment,
      username: props.user.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    });
    setComment("");
  }

  useEffect(() => {
    let unsub;
    if(props.postid){
      unsub = db.collection("posts").doc(props.postid).collection("comments").orderBy('timestamp', 'desc').onSnapshot((snapshot) => {
        setComments(snapshot.docs.map((doc) => doc.data()));
      });
    }

    return () =>{
      unsub();
    }}
  , [props.postid]);

  return (
    <div className="post">
      <div className="post-header">
        <Avatar
          className="post-avatar"
          alt={props.username}
          src="/static/images/avatar/1.jpg"
        />
        <h3>{props.username}</h3>
      </div>
      <img className="post-image" src={props.imageUrl} />
      {/* {props.caption.map(function(x){
    return (<h4 className="post-text"><strong>{x.user}:</strong> {x.cap}</h4>);}
    )} */}
      <h4 className="post-text">
        <strong>{props.username}:</strong> {props.comments}
      </h4>
      <div className="post-comments">
        {comments.map((c) => 
          (<p>
            <strong>{c.username}</strong>: {c.text}
          </p>)
        )}
      </div>
      {props.user && 
        <form className="post-form">
        <input type="text"
        value={comment}
        placeholder="Add a comment"
        className="post-input"
        onChange={(e) => setComment(e.target.value)} />
        <button
          className="post-button"
          disabled={!comment}
          type="submit"
          onClick={postComment}
        >Post</button>
        </form>
      }
      
    </div>
  );
}

export default Post;
